import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    productDetailId: "",
    appQuantity: "",
    selectedQuantity: {},
    data: [],
    selectedDosage: "",
    selectedForm: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.PRODUCT_DETAILS_REQUEST:
      return {
        ...state,
        data: [],
        isProgress: true,
      };
    case homeConstants.PRODUCT_DETAILS_SUCCESS: {
      const response = action.response.data;
      return {
        ...state,
        data: response,
        isProgress: false,
      };
    }
    case homeConstants.PRODUCT_DETAILS_FAILURE:
      return {
        ...state,
        data: [],
        productDetailId: "",
        appQuantity: "",
        selectedQuantity: {},
        error: action.error,
        isProgress: false,
      };
    case homeConstants.PRODUCT_INSURANCE_REQUEST:
      return {
        ...state,
        insuranceLoading: true,
      };
    case homeConstants.SELECTED_DOSAGE: {
      return {
        ...state,
        selectedDosage: action?.data,
      };
    }
    case homeConstants.SELECTED_FORM: {
      return {
        ...state,
        selectedForm: action?.data,
      };
    }
    case homeConstants.SELECTED_QUANTITY: {
      return {
        ...state,
        selectedQuantity: action?.data,
        productDetailId: action?.data?.productDetailId,
        appQuantity: action?.data?.isCustomQuantity
          ? action?.data?.quantity
          : 0,
      };
    }
    case homeConstants.RESET_DATA: {
      if (action.data === "productReset") {
        return {
          ...state,
          data: [],
          selectedQuantity: {},
          productDetailId: "",
          appQuantity: "",
        };
      } else {
        return {
          ...state,
        };
      }
    }
    default:
      return state;
  }
}
